import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import HeaderCard from '../components/ui/HeaderCard';
import Modal from '../../shared/components/ui/Modal';
import Layout from '../components/layout/AppLayout';
import Header from '../../shared/components/layout/Header';
import Search from '../../shared/components/ui/Search';
import Button from '../../shared/components/ui/Button';

import filter from '../../shared/assets/svg/filter.svg';

import GridWrapper from '../../shared/components/layout/GridWrapper';
import TableNew from '../../shared/components/layout/TableNew';
import { transformData } from '../../super-admin/utils/transformData';
import AddProject from '../components/forms/AddProject';
import projects from '../static/data/projects.json';
import {
  createProject,
  deleteProject,
  editProject,
  getProjectsByCompanyId,
  getProjectStats,
  handleCheckProjectDelete
} from '../services/api/implementation/impl';
import EditProject from '../components/forms/EditProject';
import { useMutation, useQuery } from '@tanstack/react-query';
import generateProjectPayload from '../utils/generateProjectPayload';
import toast from 'react-hot-toast';
import { useSelector } from 'react-redux';
import { filterData } from '../../shared/utils/filterData';
import DateFormat from '../../super-admin/utils/DateFormat';
import DeleteConfirmationModal from '../components/ui/DeleteConfirmationModal';
import { useSidebar } from '../../shared/contexts/SidebarContext';
import Headroom from 'react-headroom';
import Table from '../../shared/components/layout/Table';
import mixpanel from 'mixpanel-browser';
import Cookies from 'js-cookie';
import { Plus } from 'lucide-react';
import { useProjectsList } from '../../../contexts/ProjectsContext';
const ProjectsList = () => {
  /* 
    Hooks
  */
  const navigate = useNavigate();

  /* 
    Global state
  */
  const fileUrls = useSelector((state) => state.file.fileUrls);
  const { projects, refetchProjects } = useProjectsList();

  const companyid = useParams();
  const companyIdInt = parseInt(companyid.id, 10);
  const userId = Cookies.get('userId');

  // Track page view
  useEffect(() => {
    mixpanel.track('Projects List Viewed', {
      user_id: userId,
      company_id: companyIdInt,
      timestamp: new Date().toISOString()
    });
  }, [userId, companyIdInt]);

  /* 
    Local state
  */
  const [isOpenAddProject, setIsOpenAddProject] = useState(false);
  const [isOpenEditProject, setisOpenEditProject] = useState(false);
  const [upShift, setUpShift] = useState(6);
  const [projectsStatic, setProjectsStatic] = useState(projects);
  const [ProjectStaticId, setProjectStaticId] = useState();
  const [ProjectFilter, setProjectFilter] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [canDelete, setCanDelete] = useState(null);
  const [resData, setResData] = useState();
  const [selectedIds, setSelectedIds] = useState([]);
  const [data, setData] = useState([]);
  /* 
    Data fetching
  */

  useEffect(() => {
    if (companyIdInt && projects?.length > 0) {
      const data = projects?.filter((project) => project?.company_id === Number(companyIdInt));
      setData(data);
    }
  }, [companyIdInt, projects]);

  console.log({ data });

  const { data: projectStats, refetch: refetchProjectStats } = useQuery({
    queryKey: ['project_stats', companyIdInt],
    queryFn: () => getProjectStats(companyIdInt),
    enabled: !!companyIdInt, // Ensure the query only runs if companyIdInt is valid
    onSuccess: (result) => {
      if (
        result?.response?.status ||
        result?.message?.includes('Error') ||
        result?.name === 'AxiosError'
      ) {
        mixpanel.track('Get Project Stats API Failed', {
          user_id: userId,
          company_id: companyIdInt,
          error_message: result?.response?.data?.message || result?.message || 'Unknown error',
          timestamp: new Date().toISOString()
        });
        toast.error(
          result?.response?.data?.message || result?.message || 'Error loading project statistics'
        );
        return;
      }
      mixpanel.track('Get Project Stats API Success', {
        user_id: userId,
        company_id: companyIdInt,
        total_projects: result?.totalProjects || 0,
        completed_projects: result?.completedProjects || 0,
        incomplete_projects: result?.incompleteProjects || 0,
        timestamp: new Date().toISOString()
      });
    },
    onError: (err) => {
      mixpanel.track('Get Project Stats API Failed', {
        user_id: userId,
        company_id: companyIdInt,
        error_message: err?.response?.data?.message || err?.message || 'Unknown error',
        timestamp: new Date().toISOString()
      });
      toast.error(
        err?.response?.data?.message || err?.message || 'Error loading project statistics'
      );
    }
  });

  /* 
    Meta data
  */
  const metaData = [
    {
      _id: 1,
      type: 'information',
      name: 'Total Projects',
      data: projectStats?.totalProjects || 0
    },
    // {
    //   _id: 2,
    //   type: 'information',
    //   name: 'Total Land Area',
    //   data: `${projectStats?.totalLandArea || 0} Hector`
    // },
    {
      _id: 3,
      type: 'completed',
      name: 'Completed Projects',
      data: projectStats?.completedProjects || 0
    },
    {
      _id: 4,
      type: 'ongoing',
      name: 'Ongoing Projects',
      data: projectStats?.incompleteProjects || 0
    }
  ];

  // Updated projects array with estimated_budget
  const updatedProjects = projects?.map((project) => {
    return {
      ...project,
      estimated_budget: `$${Math.floor(Math.random() * 500000) + 100000}` // Random value between $100,000 and $600,000
    };
  });

  /* 
    Event handlers
  */
  const handleToggleAddProjectModal = useCallback(() => {
    const isOpening = !isOpenAddProject;
    setIsOpenAddProject(isOpening);

    mixpanel.track('Add Project Modal Toggled', {
      user_id: userId,
      company_id: companyIdInt,
      action: isOpening ? 'opened' : 'closed',
      timestamp: new Date().toISOString()
    });
  }, [isOpenAddProject, userId, companyIdInt]);

  const handleToggleEditProjectModal = useCallback(
    (id) => {
      const isOpening = !isOpenEditProject;
      setProjectStaticId(id);
      setisOpenEditProject(isOpening);

      mixpanel.track('Edit Project Modal Toggled', {
        user_id: userId,
        company_id: companyIdInt,
        project_id: id,
        action: isOpening ? 'opened' : 'closed',
        timestamp: new Date().toISOString()
      });
    },
    [isOpenEditProject, userId, companyIdInt]
  );

  /* 
    Data mutation
  */
  const { mutate: handleOnSubmitAddProject, isLoading: isLoadingNewUserMutation } = useMutation({
    mutationFn: (newProject) => createProject(newProject),
    onMutate: (variables) => {
      setIsSubmitting(true); // Disable the button when mutation starts
      mixpanel.track('Create Project Started', {
        user_id: userId,
        company_id: companyIdInt,
        project_name: variables?.name,
        timestamp: new Date().toISOString()
      });
    },
    onSuccess: async (result, variables) => {
      setIsSubmitting(false);

      // Check if result is an error object (API now returns errors instead of throwing)
      if (
        result?.response?.status ||
        result?.message?.includes('Error') ||
        result?.name === 'AxiosError'
      ) {
        // Handle as error
        console.error('Error creating new project', result);
        toast.error(result?.response?.data?.message || result?.message || 'Error creating project');

        mixpanel.track('Create Project Failed', {
          user_id: userId,
          company_id: companyIdInt,
          project_name: variables?.name,
          error_message: result?.response?.data?.message || result?.message || 'Unknown error',
          timestamp: new Date().toISOString()
        });
        return;
      }

      // Handle success
      toast.success('Project created successfully');
      setIsOpenAddProject(false);
      await refetchProjects(); // UI data update
      navigate(`/builder/management/company/projects/${result.id}`);
      location.reload();

      mixpanel.track('Create Project Success', {
        user_id: userId,
        company_id: companyIdInt,
        project_id: result?.id,
        project_name: variables?.name || result?.name,
        timestamp: new Date().toISOString()
      });
    },
    onError: (err, variables) => {
      setIsSubmitting(false);
      console.error('Error creating new project', err);
      toast.error(err?.response?.data?.message || err?.message || 'Error creating project');

      mixpanel.track('Create Project Failed', {
        user_id: userId,
        company_id: companyIdInt,
        project_name: variables?.name,
        error_message: err?.response?.data?.message || err?.message || 'Unknown error',
        timestamp: new Date().toISOString()
      });
    }
  });

  const { mutate: handleEditProject, isLoading: isEditingProject } = useMutation({
    mutationFn: (updatedProject) => {
      // console.log('Entering mutationFn');
      // console.log('updatedProject:', JSON.stringify(updatedProject, null, 2));
      // console.log('ProjectStaticId:', ProjectStaticId);

      if (!updatedProject) {
        throw new Error('updatedProject is null or undefined');
      }

      if (ProjectStaticId == null) {
        throw new Error('ProjectStaticId is null or undefined');
      }

      let parsedLandId;
      try {
        parsedLandId = updatedProject.land_id != null ? parseInt(updatedProject.land_id, 10) : null;
        console.log('Parsed land_id:', parsedLandId);
      } catch (error) {
        console.error('Error parsing land_id:', error);
        throw new Error(`Failed to parse land_id: ${error.message}`);
      }

      const projectToEdit = {
        ...updatedProject,
        land_id: parsedLandId
      };

      console.log('Project to edit:', JSON.stringify(projectToEdit, null, 2));

      return editProject(ProjectStaticId, projectToEdit);
    },
    onMutate: (variables) => {
      setIsSubmitting(true); // Disable the button when mutation starts
      mixpanel.track('Edit Project Started', {
        user_id: userId,
        company_id: companyIdInt,
        project_id: ProjectStaticId,
        project_name: variables?.name,
        timestamp: new Date().toISOString()
      });
    },
    onSuccess: async (result, variables) => {
      setIsSubmitting(false);

      // Check if result is an error object (API now returns errors instead of throwing)
      if (
        result?.response?.status ||
        result?.message?.includes('Error') ||
        result?.name === 'AxiosError'
      ) {
        // Handle as error
        console.error('Error editing project:', result);
        toast.error(result?.response?.data?.message || result?.message || 'Error editing project');

        mixpanel.track('Edit Project Failed', {
          user_id: userId,
          company_id: companyIdInt,
          project_id: ProjectStaticId,
          project_name: variables?.name,
          error_message: result?.response?.data?.message || result?.message || 'Unknown error',
          timestamp: new Date().toISOString()
        });
        return;
      }

      // Handle success
      console.log('Edit project succeeded');
      toast.success('Project edited successfully');
      setisOpenEditProject(false);
      await refetchProjects(); // UI data update
      location.reload();

      mixpanel.track('Edit Project Success', {
        user_id: userId,
        company_id: companyIdInt,
        project_id: ProjectStaticId,
        project_name: variables?.name || result?.name,
        timestamp: new Date().toISOString()
      });
    },
    onError: (err, variables) => {
      setIsSubmitting(false);
      console.error('Error editing project:', err);
      toast.error(err?.response?.data?.message || err?.message || 'Error editing project');

      mixpanel.track('Edit Project Failed', {
        user_id: userId,
        company_id: companyIdInt,
        project_id: ProjectStaticId,
        project_name: variables?.name,
        error_message: err?.response?.data?.message || err?.message || 'Unknown error',
        timestamp: new Date().toISOString()
      });
    }
  });

  useEffect(() => {
    setProjectFilter(data);
  }, [data]);

  /* 
    Meta data
  */
  const ProjectDataFormat = [
    'id',
    'name',
    'estimated_budget',
    'start_date',
    'compl_date',
    'actions'
  ];

  /* 
    Helper method calls
  */
  const FilterProjectData = ProjectFilter?.sort((a, b) => {
    const dateA = new Date(a.start_date);
    const dateB = new Date(b.start_date);

    // Compare by year, then by month and day
    return dateA - dateB;
  });
  console.log(FilterProjectData);
  const transformedData = FilterProjectData?.map((item) =>
    transformData(
      {
        ...item,
        start_date: item.start_date === '__' ? '---' : DateFormat(item.start_date),
        compl_date: item.completion_date === '__' ? '---' : DateFormat(item.completion_date),
        estimated_budget:
          item?.estimated_budget && !isNaN(Number(item.estimated_budget))
            ? Number(item.estimated_budget)
            : '0'
      },
      ProjectDataFormat
    )
  );

  // console.log(ProjectFilter, data);

  /* 
    Event handlers
  */
  const handleNavigateProject = useCallback(
    (id) => {
      mixpanel.track('Project Navigation Clicked', {
        user_id: userId,
        company_id: companyIdInt,
        project_id: id,
        timestamp: new Date().toISOString()
      });
      navigate(`/builder/management/company/projects/${id}`);
    },
    [navigate, userId, companyIdInt]
  );

  /* 
    Effects
  */
  useEffect(() => {
    refetchProjects();
    refetchProjectStats();
  }, [isOpenAddProject, isOpenEditProject, refetchProjects, refetchProjectStats]);

  const { mutate: handleCheckDelete } = useMutation({
    mutationFn: (id) => handleCheckProjectDelete(id),
    onMutate: (id) => {
      setIsSubmitting(true); // Disable the button when mutation starts
      mixpanel.track('Check Project Delete Dependencies Started', {
        user_id: userId,
        company_id: companyIdInt,
        project_id: id,
        timestamp: new Date().toISOString()
      });
    },
    onSuccess: async (result, id) => {
      setIsSubmitting(false);

      // Check if result is an error object (API now returns errors instead of throwing)
      if (
        result?.response?.status ||
        result?.message?.includes('Error') ||
        result?.name === 'AxiosError'
      ) {
        // Handle as error
        console.error('Error checking dependencies', result);
        toast.error(
          result?.response?.data?.message || result?.message || 'Error checking dependencies'
        );

        mixpanel.track('Check Project Delete Dependencies Failed', {
          user_id: userId,
          company_id: companyIdInt,
          project_id: id,
          error_message: result?.response?.data?.message || result?.message || 'Unknown error',
          timestamp: new Date().toISOString()
        });
        return;
      }

      // Handle success
      const project = FilterProjectData?.find((item) => parseInt(item.id) === parseInt(id));
      const projectName = project?.name || 'Project';

      if (result.canDelete) {
        setCanDelete('yes');
        setResData({ name: projectName });
        setSelectedIds([parseInt(id)]);

        mixpanel.track('Check Project Delete Dependencies Success', {
          user_id: userId,
          company_id: companyIdInt,
          project_id: id,
          project_name: projectName,
          can_delete: true,
          timestamp: new Date().toISOString()
        });
      } else {
        // Fallback if not found
        setResData({ ...result, name: projectName });
        setCanDelete('no');

        mixpanel.track('Check Project Delete Dependencies Success', {
          user_id: userId,
          company_id: companyIdInt,
          project_id: id,
          project_name: projectName,
          can_delete: false,
          dependencies_count: result?.accommodations?.length || 0,
          timestamp: new Date().toISOString()
        });
      }
    },
    onError: (err, id) => {
      setIsSubmitting(false);
      console.error('Error checking dependencies', err);
      toast.error(err?.response?.data?.message || err?.message || 'Error checking dependencies');

      mixpanel.track('Check Project Delete Dependencies Failed', {
        user_id: userId,
        company_id: companyIdInt,
        project_id: id,
        error_message: err?.response?.data?.message || err?.message || 'Unknown error',
        timestamp: new Date().toISOString()
      });
    }
  });

  const { mutate: handleDeleteFn } = useMutation({
    mutationFn: (payload) => deleteProject(payload),
    onMutate: (variables) => {
      setIsSubmitting(true); // Disable the button when mutation starts
      mixpanel.track('Delete Project Started', {
        user_id: userId,
        company_id: companyIdInt,
        project_ids: variables?.ids,
        is_bulk: variables?.ids?.length > 1,
        timestamp: new Date().toISOString()
      });
    },
    onSuccess: (result, variables) => {
      setIsSubmitting(false);

      // Check if result is an error object (API now returns errors instead of throwing)
      if (
        result?.response?.status ||
        result?.message?.includes('Error') ||
        result?.name === 'AxiosError'
      ) {
        // Handle as error
        console.error('Error deleting project', result);
        toast.error(result?.response?.data?.message || result?.message || 'Error deleting project');

        mixpanel.track('Delete Project Failed', {
          user_id: userId,
          company_id: companyIdInt,
          project_ids: variables?.ids,
          is_bulk: variables?.ids?.length > 1,
          error_message: result?.response?.data?.message || result?.message || 'Unknown error',
          timestamp: new Date().toISOString()
        });
        return;
      }

      // Handle success
      toast.success('Project Deleted Successfully');
      refetchProjects();

      mixpanel.track('Delete Project Success', {
        user_id: userId,
        company_id: companyIdInt,
        project_ids: variables?.ids,
        is_bulk: variables?.ids?.length > 1,
        timestamp: new Date().toISOString()
      });
    },
    onError: (err, variables) => {
      setIsSubmitting(false);
      console.error('Error deleting project', err);
      toast.error(err?.response?.data?.message || err?.message || 'Error deleting project');

      mixpanel.track('Delete Project Failed', {
        user_id: userId,
        company_id: companyIdInt,
        project_ids: variables?.ids,
        is_bulk: variables?.ids?.length > 1,
        error_message: err?.response?.data?.message || err?.message || 'Unknown error',
        timestamp: new Date().toISOString()
      });
    }
  });

  const HandleDelete = (data) => {
    const payload = { ids: data };

    mixpanel.track('Delete Project Button Clicked', {
      user_id: userId,
      company_id: companyIdInt,
      project_ids: data,
      is_bulk: data?.length > 1,
      timestamp: new Date().toISOString()
    });

    handleDeleteFn(payload);
  };

  /* 
    JSX
  */

  const { collapsed } = useSidebar();
  return (
    <>
      {isOpenAddProject && (
        <Modal
          isDirty={true}
          confirmOnClose={true}
          width={60}
          name="Add Project"
          onClose={handleToggleAddProjectModal}>
          <AddProject
            onSubmit={handleOnSubmitAddProject}
            upShift={upShift}
            isSubmitting={isSubmitting}
            setUpShift={setUpShift}
            onClose={handleToggleAddProjectModal}
          />
        </Modal>
      )}

      {/* Edit Project Modal */}

      {isOpenEditProject && (
        <Modal
          isDirty={true}
          confirmOnClose={true}
          width={88}
          name="Edit project"
          onClose={handleToggleEditProjectModal}
          upShift={upShift * 10}>
          <EditProject
            id={ProjectStaticId}
            ProjectData={transformedData}
            upShift={upShift}
            isSubmitting={isSubmitting}
            setUpShift={setUpShift}
            onSubmit={handleEditProject}
            onClose={handleToggleEditProjectModal}
          />
        </Modal>
      )}

      {canDelete === 'no' && (
        <Modal
          isDirty={true}
          confirmOnClose={false}
          name={`Cannot delete '${resData?.name || 'this project'}'`}
          onClose={() => setCanDelete(null)}
          width={45}>
          <div className="flex flex-col justify-center align-center ">
            <p className="text-center">
              Looks like this project has dependencies, please delete following cccomodations to
              proceed
            </p>
            <div className="flex justify-start, align-middle flex-wrap bg-[#f5f7f8] p-2 rounded-[5px] mt-4">
              {resData &&
                resData.reason?.map((r, index) => (
                  <span className="mt-[2px] mr-[4px] text-[#535353]" key={index}>
                    {index + 1}.{r}
                    {index < resData.reason.length - 1 ? ', ' : ''}
                  </span>
                ))}
            </div>
          </div>
        </Modal>
      )}

      {canDelete === 'yes' && (
        <Modal
          isDirty={true}
          confirmOnClose={false}
          name={'Confirmation'}
          onClose={() => {
            setCanDelete(null);
            setSelectedIds([]);
          }}
          width={45}>
          <DeleteConfirmationModal
            name={resData.name}
            title={'project'}
            onClose={() => setCanDelete(null)}
            data={transformedData}
            type={'project'}
            setCanDelete={setCanDelete}
            onDeleteClick={HandleDelete}
            setSelectedIds={setSelectedIds}
            selectedIds={selectedIds}
          />
        </Modal>
      )}

      <Layout>
        {/* Header */}
        <div
          className={`fixed top-0 z-10 transition-all duration-300 ease-in-out bg-white
    ${collapsed ? 'left-[76px] w-[calc(100%-76px)]' : 'left-64 w-[calc(100%-16rem)]'}
  `}>
          <Header data={{ name: 'Company > Projects' }} backArrow={true} />
        </div>

        {/* Cards */}
        <div
          className={`transition-all duration-300 ease-in-out mt-[4rem]  flex flex-col items-center`}>
          <div className="w-full flex justify-between items-center px-6 py-4 bg-stone-100 space-x-4">
            {metaData?.map((item) => (
              <HeaderCard
                data={{ key: item?.name, value: item.data, type: item.type }}
                key={item?._id}
              />
            ))}
          </div>
          {/* <Headroom
            upTolerance={0}
            downTolerance={10}
            offset={10}
            style={{
              transition: 'all 0.2s ease-in-out',
              position: 'fixed',
              top: '4rem',
              left: collapsed ? '76px' : '16.6%',
              right: '0',
              zIndex: 2
            }}> */}
          {/* Main content */}

          <div className="fixed bottom-8 right-8 z-50">
            <Button
              displayType="primary"
              onClick={() => {
                mixpanel.track('Add Project Button Clicked', {
                  user_id: userId,
                  timestamp: new Date().toISOString()
                });
                handleToggleAddProjectModal();
              }}
              customStyle={{
                borderRadius: '50%',
                width: '50px',
                height: '50px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)'
              }}>
              <Plus size={24} color="white" />
            </Button>
          </div>
          {/* </Headroom> */}

          {/* Table content */}

          <GridWrapper width={100}>
            <div className="table-container h-[calc(100vh-15.5rem)] overflow-auto">
              <style>{`
            .table-container .table-body {
              position: static !important;
              overflow-y: visible !important;
              max-height: none !important;
              height: auto !important;
              top: auto !important;
              padding-bottom: 0 !important;
            }
            .table-container .table-container {
              height: auto !important;
            }
            .table-container > div {
              height: auto !important;
            }
            .table-container .w-full.justify-between.bg-gray-200 {
              position: sticky !important;
              z-index: 10 !important;
              background-color: #e5e7eb !important;
              box-shadow: 0 2px 4px rgba(0,0,0,0.1) !important;
            }
          `}</style>
              <Table
                headers={[
                  'Project',
                  'Estimated budget',
                  'Start Date',
                  'Completion Date',
                  'Actions'
                ]}
                data={transformedData}
                identifier={'id'}
                onEdit={(id) => handleToggleEditProjectModal(id)}
                isEditEnable={true}
                handleRowClick={handleNavigateProject}
                isDeleteEnable={true}
                onDelete={handleCheckDelete}
                isWrap={true}
              />
            </div>
          </GridWrapper>
        </div>
      </Layout>
    </>
  );
};

export default ProjectsList;
